import { api } from './client';
import type {
  ProjectMember,
  ProjectMembersListResponse,
  MyRoleResponse,
  UpdateMemberRolePayload,
  TransferProjectOwnershipPayload,
} from '@/types';

export const projectMembersApi = {
  getMyRole: (projectId: string) =>
    api.get<MyRoleResponse>(`/projects/${projectId}/members/my-role`),

  list: (projectId: string) =>
    api.get<ProjectMembersListResponse>(`/projects/${projectId}/members`),

  updateRole: (projectId: string, userId: string, data: UpdateMemberRolePayload) =>
    api.patch<ProjectMember>(`/projects/${projectId}/members/${userId}`, data),

  remove: (projectId: string, userId: string) =>
    api.delete<{ success: boolean }>(`/projects/${projectId}/members/${userId}`),

  // project-settings-mockup item 18: self-leave — DELETE /members/me, distinct
  // from remove() above (verified against backend WEB-205 §F9: any non-owner
  // member may leave, project-members.controller.ts leaveProject/:Delete('me')).
  leave: (projectId: string) =>
    api.delete<{ success: boolean }>(`/projects/${projectId}/members/me`),

  // WEB-1559 — передача владения проектом. Маршрут живёт под /members, а не
  // на /projects/:id/transfer-ownership: серверные стражи читают параметр
  // маршрута с именем projectId, а в контроллере проектов он зовётся :id
  // (шрам WEB-1253). Отвечает строкой НОВОГО владельца; прежний владелец
  // становится администратором той же транзакцией — см. reducer слайса.
  transferOwnership: (projectId: string, data: TransferProjectOwnershipPayload) =>
    api.post<ProjectMember>(
      `/projects/${projectId}/members/transfer-ownership`,
      data,
    ),
};
